/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_TitleInputs */

const vi_expense_title = /** @type {(inputs: Expense_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khoản chi`)
};

/**

* @param {Expense_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_title = /** @type {((inputs?: Expense_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_title(inputs)
});